<template>
  <div class="content-limit-container">
    PDF download contains up to 100 {{ mediaType }}. To see a different set of {{ mediaType }},
    <br />
    please modify the filter or sorting options.
  </div>
</template>

<script>
import { defineComponent } from 'vue';

const comp = defineComponent({
  name: 'MediaContentLimit',
  props: {
    mediaType: {
      type: String,
      default: 'posts',
    },
  },
});
export default comp;
</script>

<style lang="postcss" scoped>
.content-limit-container {
  display: block;
  height: var(--space-40);
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: var(--space-20);
  text-align: center;
}
</style>
